/**
 * AmbiguousPatientsBanner
 *
 * Persistent warning banner for patients that matched multiple existing records.
 */

import { Link as RouterLink } from 'react-router-dom';
import { Alert, Link } from '@mui/material';

import type { AmbiguousPatientsBannerProps } from '../ImportReviewWizard.types';

export const AmbiguousPatientsBanner = ({ count }: AmbiguousPatientsBannerProps) => {
  if (count === 0) return null;

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {count} record{count === 1 ? '' : 's'} matched multiple existing patients and will be
      skipped. Use{' '}
      <Link
        component={RouterLink}
        to="/patients/merge"
        underline="always"
        color="inherit"
        fontWeight={600}
      >
        Merge Duplicates
      </Link>{' '}
      to resolve these after import.
    </Alert>
  );
};
